<template>
<div v-if="media">
  <videoplayer v-if="video" :src="video" :poster="poster" :edit="true" v-on:seek="$parent.playTime=$event" v-on:duration="$parent.duration=$event" :chapters="chapters" />
  <videoplayer v-if="video2" :src="video2" :poster="poster" :edit="true" v-on:seek="$parent.playTime=$event" v-on:duration="$parent.duration=$event" :chapters="chapters" />
  <div class="tv-inner" v-else-if="photo">
    <div class="video-container">
      <img :src="photo" />
    </div>
  </div>
  
  <a href="" v-on:click.prevent="$emit('delete')" class="remove">&times;</a>
</div>
<div v-else>
  <div class="video-uploader" v-if="mode==null">
    <label>Drag and drop video here <span></span> or click to select video</label>
    <input type="file" ref="filechooser" v-on:change="uploadFile" />
  </div>
  <div class="video-uploader video-up-2" v-if="mode==null" v-on:click="uploadedListShown=true">
    <label>select uploaded video <span></span></label>
    <form v-if="uploadedListShown">
      <select v-model="uploadedVideo">
        <option v-for="vid in uploadedVideos" :value="vid">{{ "" && vid.index }} {{ vid.name }}</option>
      </select>
      <button v-on:click.prevent="selectVideo">Select</button>
    </form>
  </div>
  <div class="upload-progress" v-if="mode=='uploading'">
    <div class="progress-bar" :style="{width: progress*100+'%'}"></div>
    <label>Uploading {{ progress!==null?Math.round(progress*100)+'%':'' }}</label>
  </div>
  <div class="upload-progress" v-if="mode=='processing'">
    <div class="progress-bar" :style="{width: progress*100+'%'}"></div>
    <label>Processing {{ progress!==null?Math.round(progress*100)+'%':'' }}</label>
  </div>
</div>
</template>

<script>


import api from './api';
import FileUpload from './FileUpload';
export default {
  props: ["media", "thumbnail", "chapters"],
  data: ()=>({
    mode: null,
    progress: null,
    uploadedListShown: false,
    uploadedVideo: null,
    uploadedVideos: [],
    defaultPhotoStore: 1,
    defaultVideoStore: 2,
    uploadedVideoId: null,
  }),
  computed: {
    photo() {
      var media=this.media;
      if (!media || !media.store || media.store.plugin!="Local")
        return null;
      return media.store.rootUrl+media.path;
    },
    video() {
      var media=this.media;
      if (!media || !media.store || media.store.plugin!="Video")
        return null;
      return media.store.rootUrl+media.path;
    },
    video2() {
      var media=this.media;
      if (!media || !media.store || media.store.plugin!="Video2")
        return null;
      return media.path;
    },
    poster() {
      if (this.thumbnail) {
        var media=this.thumbnail;
        if (!media || !media.store || media.store.plugin!="Local")
          return null;
        return media.store.rootUrl+media.path;
      }
      var media=this.media;
      if (media && media.store && media.store.plugin=="Video2")
        return media.thumbnail;
      if (!media || !media.store || media.store.plugin!="Video")
        return null;
      return media.store.rootUrl+media.path.replace(/\/[^/]+$/, "/"+media.thumbnail);
    },
  },
  methods: {
    uploadFile($event) {
      var file=$event.target.files[0];
      if (!file)
        return;
      if (file.name.toLowerCase().match(/\.(mp4|mkv|ts|mov|webm)$/)) {
        this.uploadVideo(file);
      } else {
        this.uploadImage(file);
      }
    },
    async uploadImage(file) {
      this.mode='uploading';
      var result=await api.create("Media", {store: this.defaultPhotoStore});
      if (result.id) {
        await api.upload("Media", result.id, file);
      }
      var media=(await api.get("Media", result.id)).item;
      this.mode=null;
      this.$emit("set", media);
    },
    async uploadVideo(file) {
      addEventListener("beforeunload", this.unloadListener, {capture: true});
      window.appUploadProgress={
        updateProgress: (item)=>{
          var progress=item.progress.reduce((sum,item)=>sum+item[1], 0);
          this.progress=progress/item.file.size;
          if (item.done) {
            this.uploadedVideoId=item.id;
            removeEventListener("beforeunload", this.unloadListener, {capture: true});
            this.startProcessingCheck();
          }
        }
      };
      FileUpload.start(file);
      this.mode='uploading';
      this.progress=0;
    },
    unloadListener(event) {
      event.preventDefault();
      return event.returnValue="Video is still being uploaded. Are you sure you want to close this page?";
    },
    startProcessingCheck() {
      this.mode='processing';
      this.progress=.5;
      this.processingCheckInterval=setInterval(async ()=>{
        await this.listVideos();
        var video=this.uploadedVideos.find(a=>a.id==this.uploadedVideoId);
        var previewsDone=false;
        console.log(video);
        if (video) {
          for(var variant of video.variants) {
            if (["preview", "preview0", "preview1", "preview2"].indexOf(variant.level)!=-1)
              previewsDone=!!variant.storagemain;
          }
        }
        if (previewsDone) {
          this.stopProcessingCheck();
          this.uploadedVideo=video;
          this.selectVideo();
        }
      }, 4000);
    },
    stopProcessingCheck() {
      this.mode=null;
      this.progress=null;
      clearInterval(this.processingCheckInterval);
    },
    async listVideos(filename) {
      this.uploadedVideos=(await FileUpload.list()).reverse().filter(a=>a.status!="Deleted" && a.status!="Uploading").map(a=>({
        name: a.filename,
        path: "/play/"+a.videokey+".m3u8",
        id: a.videokey,
        thumbnail: "https://v-edge-01.kathirossnash.com/v/01/"+a.videokey+"/preview.jpg",
        duration: 10,
        modified: 0,
        variants: a.variants,
      }));
    },
    async selectVideo() {
      if (!this.uploadedVideo)
        return;
      var result=(await api.create("Media", {
        store: 3,
        path: this.uploadedVideo.path,
        name: this.uploadedVideo.name,
        thumbnail: this.uploadedVideo.thumbnail,
      }, true)).item;
      this.mode=null;
      this.progress=null;
      this.uploadedListShown=false;
      this.$emit("set", result);
    },
    async getDefaultVideoStore() {
      var store=(await api.list("Mediastore", {plugin: "Video2", defstore: 1})).items[0];
      if (store)
        this.defaultVideoStore=store.id;
//       videoUploader.urlUpload=uploadUrl=store.config.uploadUrl;
//       listUrl=store.config.listUrl;
//       videoUploader.urlProcess=processUrl=store.config.processUrl;
      this.listVideos();
    },
    async getDefaultPhotoStore() {
      var store=(await api.list("Mediastore", {plugin: "Local", defstore: 1})).items[0];
      if (store)
        this.defaultPhotoStore=store.id;
    },
  },
  mounted() {
    this.getDefaultVideoStore();
    this.getDefaultPhotoStore();
  },
  beforeDestroy() {
    this.stopProcessingCheck();
  },
}
</script>
